<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click.self="$emit('close')">
        <div class="modal-container">
          <h2 class="modal-title">
            {{ modal.title }}
          </h2>
          <img :src="modal.WorkImg">
          <div class="skills">
            <ul>
              <li v-for="skill in modal.skills">{{ skill }}</li>
            </ul>
          </div>
          <div class="date">
            <div class="sub-title">
              期間
            </div>
            <div class="date-content">
            {{ modal.date }}
            </div>
          </div>
          <div class="description">
            <div class="sub-title">
              説明
            </div>
            <div class="description-content">
              {{ modal.description }}
            </div>
          </div>
          <div class="links" v-show="modal.links">
            <div class="sub-title">
              リンク
            </div>
            <ul class="links-content">
              <li v-for="(link, key) in modal.links"><a :href="link">{{ key }}</a></li>
            </ul>
          </div>
          <button class="modal-close-button" @click="$emit('close')">
            CLOSE
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import {mapGetters } from 'vuex'

  export default {
    name: 'Modal',
    computed: {
      ...mapGetters('Works',{
        'modal': 'getModal'
      })
    }

  }
</script>

<style lang="stylus" scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.1);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 50%;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    box-sizing: border-box;
    max-height: 100vh;
    overflow-y: auto;
  }
  @media screen and (max-width: 479px){
    .modal-container {
      width: 85%;
    }

  }

  .modal-title{
    color: #beb5fc;
  }
  // オーバーレイのトランジション
  .modal-enter-active, .modal-leave-active {
    transition: opacity 0.4s;

    .modal-container  {
      transition: opacity 0.4s, transform 0.4s;
    }
  }

  // ディレイを付けるとモーダルウィンドウが消えた後にオーバーレイが消える
  .modal-leave-active {
    transition: opacity 0.6s ease 0.4s;
  }

  .modal-enter, .modal-leave-active{
    opacity: 0;
    .modal-container {
      opacity: 0;
      transform: translateY(-20px);
    }
  }

  img{
    width: 45%;
  }
  .date, .description, .links{
    margin-top: 35px;
  }
  .description-content{
    font-size: 14px;
  }
  .modal-close-button{
    text-decoration: none;
    color: #beb5fc;
    background-color: #fff;
    padding: 5px;
    border-radius: 5px;
    border: solid 2px #beb5fc;
    text-align: center;
    vertical-align: middle;
    overflow: hidden;
    font-weight: bold;
    transition: .4s;
    cursor: pointer;
  }
  .modal-close-button:hover{
    background: #d2cafc;
  }
  .links .links-content{
    padding-inline-start: 0;
    margin:0;
  }
  .links .links-content li{
    display: inline-block;
    margin: 10px;
    font-size: 12px;
  }
  .skills ul{
    padding: 0;
  }
  .skills ul li{
    font-size: 12px;
    display: inline-block;
    vertical-align: middle;
    border: solid #2c3e50 1px;
    margin-right: 2px;
    padding: 0.25em;
    background: #beb5fc;
    border-radius: 15px 0px 0px 15px;
  }
  .skills ul li:before{
    display:inline-block;
    /*以下白丸つくる*/
    content:'';
    width:1em;
    height: 1em;
    background: #fff;
    border-radius: 50%;
    margin-right: 8px;
  }
  .sub-title{
    font-size: 20px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/Modal.vue